export class Weather {

    Temperature: string;
    WeatherSymbolUrl: string;
}

export class Forecast {
    Time: Date;
    Temperature: string;
    WeatherState: string;
    WeatherSymbolUrl: string;
    Precipitation: string;
    WindSpeed: string;

}
